import React, { Component } from 'react';


export default class ScheduleEvent extends Component {
  render() {
    let speaker = this.props.speakerData;
    let data;
    if (speaker.speakerShortViews.length > 0) {
      data = (
        <div>
          <div className='room-event__speaker'>
            <a href={'/speaker?id=' + speaker.speakerShortViews[0].idStr} className='room-event__speaker-link'>
                {speaker.speakerShortViews[0].userView.fullName},
            </a>
          </div>
          <div className='room-event__speaker-job-position'>
            <a target='_blank' className='room-event__speaker-job-link' href={speaker.speakerShortViews[0].company.url}>
              {speaker.speakerShortViews[0].company.name}
            </a>
            , {speaker.speakerShortViews[0].jobPosition}
            , {speaker.speakerShortViews[0].userView.cityName}
          </div>
          <div className='room-event__event'>
            <a href={speaker.roomEventShortView.roomEventUrl} className='room-event__title-link'>{speaker.roomEventShortView.title}</a>
            <div className='room-event__description'>{speaker.roomEventShortView.description}</div>
          </div>
        </div>
      )
    } else {
      data = (
        <div className='room-event__event'>
          <div className='room-event__title'>{speaker.roomEventShortView.title}</div>
          <div className='room-event__description'>{speaker.roomEventShortView.description}</div>
        </div>
      )
    }
    return (
      <div className='schedule__room-event' key={speaker.roomEventShortView.idStr}>
        {data}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/schedule-page/blocks/ScheduleEvent.js